<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"
      :useFieldInfo="true"
      :typeslabel="{
        date: '등록일',
      }"
      :types="['field_name', '부서명_과', 'com_name', 'manager_name', 'writer_name', 'date']"
      :options="[
        { type: 'text', label: '작성자', readonly: true },
        { type: 'daterang', label: '사업기간' },
      ]"
    />

    <!-- 구분 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 구분</h5>

      <div class="w-full grid grid-cols-4">
        <radio-group class="justify-between" v-model="form.구분" flex :items="['상반기', '하반기']" />
      </div>
    </div>

    <table-inspect-merge
      class="mt-28px"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      v-model="form.inspectList"
      title="반기별 보고"
      table-header-title="법적의무사항"
      :table-header-note="[{ text: '비고', width: '300' }]"
      :table-header-check="[
        { text: '양호', value: 'Yes', width: '100' },
        { text: '미흡', value: 'No', width: '100' },
        { text: '해당없음', value: 'N/A', width: '100' },
      ]"
    />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" title="파일첨부" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DateSelectorRang from "../../../../components/selector/DateSelectorRang.vue";
import FieldSelector from "../../../../components/selector/FieldSelector.vue";
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import * as inspectData from "@/views/boards/single-page/1084/inspectData";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import SignField from "@/components/SignField.vue";
import TableCustom from "@/components/TableCustom.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";

export default {
  components: {
    RadioGroup,
    TableCustom,
    SignField,
    NameWithSignatureRow,
    PhotoUploadGridModule,
    TableInspectMerge,
    FieldSelector,
    DateSelectorRang,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {},
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    board: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value && value.writer) {
          if (!this.form.stdInfo.작성자 || this.form.stdInfo.작성자 === "") {
            const writerName = value.writer && value.writer.name ? value.writer.name : null;
            if (writerName) {
              this.form.stdInfo.작성자 = writerName;
            }
          }
        }
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        photoList: [],
        fileList: [],

        inspectList: inspectData.inspectTable
      },
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
